import React, { Component } from 'react';
import Svg from './MoreVert.svg';

export default class MoreVertIcon extends Component {
    render = () => {
        return (
            <img
                src={Svg}
                {...this.props}
                style={{ opacity: '0.7', width: '22px' }}
                alt="More Vert Icon"
            />
        );
    };
}
